export const allPaths = {
    dashboard: "/",
    timeline: "/timeline",
    watch: "/watch",
    search: "/search",
    video: "/video",
} as const


export const allQueryParam = {
    series: "series",
    video: "video",
    searchQuery: "search_query",
} as const
